module.exports = __webpack_public_path__ + "img/back_address_active1.5eb691b4.png";